import { isOnlinePlannerAllowedForModel } from '@sb/robot';

import { useFeatureFlag } from './useFeatureFlag';
import { useModelTypeOrNull } from './useModelType';

/**
 * Whether this arm may reach the online planner.
 *
 * Reads the model as `useModelTypeOrNull` rather than `useModelType`: the
 * latter's RO1 default would let the UI offer a path the server then rejects,
 * so every consumer must read it the null-returning way. Having one hook means
 * none of them has to remember that.
 */
export function useIsOnlinePlannerAllowedForModel(): boolean {
  const modelType = useModelTypeOrNull();
  const onlinePlannerThor = useFeatureFlag('onlinePlannerThor');
  const onlinePlannerSpark = useFeatureFlag('onlinePlannerSpark');

  return isOnlinePlannerAllowedForModel(modelType, {
    onlinePlannerThor,
    onlinePlannerSpark,
  });
}
